var _circle, _ellipse, _path, _path2, _line, _line2, _path3, _path4, _path5, _line3, _line4, _line5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmotionSick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 378,
    viewBox: "0 0 290 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145.005,
    cy: 144.833,
    r: 144.833,
    fill: "#D8AD85"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145,
    cy: 144.984,
    rx: 145,
    ry: 144.5,
    fill: "url(#paint0_linear_1486_9779)",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.753 169.744L186.494 153.584L196.26 155.864L187.585 172.587L177.753 169.744Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 190.984L177.5 164.484L190 170.484L176 197.984L163.5 190.984Z",
    fill: "#FF0202"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 109.483,
    y1: 102.321,
    x2: 65.0358,
    y2: 125.451,
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: -2.5,
    x2: 52.6056,
    y2: -2.5,
    transform: "matrix(0.887075 0.461625 0.461625 -0.887075 177.375 98.9492)",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.07 187.74L101.655 210.333C100.43 210.97 98.9202 210.494 98.2828 209.269C97.6455 208.044 98.1217 206.535 99.3465 205.897L143.794 182.767C144.202 182.555 144.642 182.466 145.07 182.487C145.499 182.466 145.938 182.555 146.346 182.767L190.794 205.897C192.019 206.535 192.495 208.044 191.858 209.269C191.22 210.494 189.711 210.97 188.486 210.333L145.07 187.74Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.5 156.484L163.188 191.843L176.355 198.92L194.179 162.705C197.5 156.484 190.643 153.934 190.643 153.934C187 152.484 184.007 153.777 182.5 156.484Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.208 325.258C108.043 325.258 110.55 326.083 112.729 327.733C114.93 329.384 116.654 331.711 117.903 334.716C119.172 337.72 119.807 341.222 119.807 345.221C119.807 349.241 119.172 352.754 117.903 355.758C116.654 358.763 114.93 361.09 112.729 362.741C110.529 364.37 108.022 365.185 105.208 365.185C102.393 365.185 99.8755 364.37 97.6538 362.741C95.4533 361.09 93.7288 358.763 92.4805 355.758C91.2533 352.754 90.6396 349.241 90.6396 345.221C90.6396 341.222 91.2533 337.72 92.4805 334.716C93.7288 331.711 95.4533 329.384 97.6538 327.733C99.8755 326.083 102.393 325.258 105.208 325.258ZM105.208 330.653C103.472 330.653 101.938 331.246 100.605 332.431C99.2725 333.616 98.2357 335.308 97.4951 337.509C96.7546 339.688 96.3843 342.259 96.3843 345.221C96.3843 348.162 96.7546 350.733 97.4951 352.934C98.2357 355.134 99.283 356.827 100.637 358.012C101.991 359.175 103.515 359.757 105.208 359.757C106.943 359.757 108.477 359.175 109.81 358.012C111.143 356.827 112.169 355.134 112.888 352.934C113.629 350.733 113.999 348.162 113.999 345.221C113.999 342.259 113.629 339.688 112.888 337.509C112.169 335.308 111.143 333.616 109.81 332.431C108.477 331.246 106.943 330.653 105.208 330.653ZM134.248 377.848H128.25V320.973H134.248V377.848ZM143.42 348.395H132.883V343.253H143.42V348.395ZM197.979 353.759H146.118V348.903H197.979V353.759ZM193.123 327.924H150.879V323.004H193.123V327.924ZM192.869 343.793H151.133V338.937H192.869V343.793ZM165.161 342.079H159.163V325.036H165.161V342.079ZM184.839 342.079H178.809V325.036H184.839V342.079ZM191.663 377.15H152.339V359.123H191.663V377.15ZM158.306 372.262H185.759V363.82H158.306V372.262Z",
    fill: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 177.657,
    y1: 163.222,
    x2: 183.737,
    y2: 165.828,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 174.657,
    y1: 169.222,
    x2: 180.737,
    y2: 171.828,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 171.657,
    y1: 175.222,
    x2: 177.737,
    y2: 177.828,
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_9779",
    x1: 176.912,
    y1: -97.8608,
    x2: 92.5585,
    y2: 188.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#FF0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmotionSick);
export default __webpack_public_path__ + "static/media/IconEmotionSick.aa2e6f215a119a1da107d29a15092f09.svg";
export { ForwardRef as ReactComponent };